package com.milta.core.localization.translations.es

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Ruta",
    navEcoDriving = "Eco conducción",
    navCommunity = "Comunidad",
    navRewards = "Recompensas",
    navHome = "Inicio",
    navRoutes = "Rutas",
    navTeam = "Equipo",
    navProfile = "Perfil",
)
